import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'

import { ApplicationsDashboard, ApplicationDetailPage } from '../components'
import { CertificatesPage } from '../../certificates'
import { useCombos, useCustomCombo } from '../../../features/combos/hooks'
import { AppContext } from '../../../features/application-detail/contexts'
import { useApplicationUserPermitsContext } from '../contexts'

export const ApplicationsRouter = () => {
  const userPermits = useApplicationUserPermitsContext()
  useCombos(userPermits.combos)
  useCustomCombo(userPermits.customCombos)

  const ApplicationDetail = () => {
    return (
      <AppContext>
        <ApplicationDetailPage />
      </AppContext>
    )
  }

  return React.useMemo(
    () => (
      <Routes>
        <Route path="/" element={<ApplicationsDashboard />} />
        <Route path="/:appId" element={<ApplicationDetail />} />
        <Route path="/:appId/certificates" element={<CertificatesPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    ),
    []
  )
}
